import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, signal, effect } from '@angular/core';
import { FilterItem } from './models/FilterItem';

@Component({
    selector: 'density-filter-popover',
    templateUrl: './density-filter-popover.component.html',
    styleUrl: './density-filter-popover.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DensityFilterPopoverComponent {
    @Input()
    set resetSignal(value: boolean) {
        this.resetTrigger.set(value);
    }

    @Input()
    filteredItems: FilterItem[] = [];

    @Output()
    filterApplied = new EventEmitter<FilterItem[]>();

    resetTrigger = signal(false);
    filterValue = signal('');

    constructor() {
        effect(() => {
            if (this.resetTrigger()) {
                this.filterValue.set('');
            }
        });
    }

    get displayedItems(): FilterItem[] {
        const filterValue = this.filterValue();
        if (!filterValue) {
            return this.filteredItems;
        }
        return this.filteredItems.filter(item => item.value.toLowerCase().includes(filterValue.toLowerCase()));
    }

    selectItem(item: FilterItem): void {
        item.selected = !item.selected;
        this.filterApplied.emit(this.filteredItems);
    }

    onFilterValueChange(value: string): void {
        this.filterValue.set(value);
    }
}
